import React from 'react';
import { Box, Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RefreshIcon from '@mui/icons-material/Refresh';

const AuditToolbar = ({
  selectedCount = 0,
  total = 0,
  page = 1,
  limit = 10,
  onExport,
  onBulkDelete,
  onRefresh,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleExportClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <Box sx={{ mb: 1 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Display: {start}-{end} sur {total} {selectedCount > 0 && `| Selected: ${selectedCount}`}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" startIcon={<RefreshIcon />} onClick={onRefresh}>Refresh</Button>
          <Button
            variant="outlined"
            startIcon={<IosShareIcon />}
            onClick={handleExportClick}
          >
            Export
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem onClick={() => { handleClose(); onExport?.('page'); }}>Current page</MenuItem>
            <MenuItem onClick={() => { handleClose(); onExport?.('all'); }}>All (limited)</MenuItem>
          </Menu>
          <Button
            color="error"
            variant="contained"
            startIcon={<DeleteForeverIcon />}
            disabled={selectedCount === 0}
            onClick={onBulkDelete}
          >
            Delete
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AuditToolbar;
